import React from 'react';
import ReactDOM from 'react-dom/client';
import './output.css';  // Caminho do arquivo gerado
//import './index.css';  //
import "./firebase";
//import "./assets/css/custom.css";
//import "./assets/css/theme.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
